import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import { ReoccurringMeetingForm } from "./ReoccurringMeetingForm";
import type { Meeting } from "@repo/types";
import { MEETING_MOTIF } from "@/lib/constants";

export const ReoccurringMeetingDialog = ({
  tenantId,
  meeting,
  open: outerOpen,
  setOpen: outerSetOpen,
}: {
  tenantId: string;
  meeting: Meeting;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={MEETING_MOTIF}>
          <DialogTitle>Reoccurring Meeting</DialogTitle>
        </DialogHeader>
        <ReoccurringMeetingForm
          tenantId={tenantId}
          meeting={meeting}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
